//requested by FreshEgg
export const getUserType = (email: string) =>
  email?.includes("@londond.edu") ? "internal" : "prospect";
//requested by Croud
export const getUserTypeV2 = (email: string) =>
  email?.includes("@londond.edu") ? "Registered" : "Guest";
